export default __webpack_public_path__ + "static/media/voluum_logo.19010ba4.png";